import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

const EraseTool = () => {
  return (
    <div className="space-y-4" data-testid="erase-tool">
      <div>
        <Label>Erase Text Mode</Label>
        <p className="text-sm text-muted-foreground mt-1.5">
          Drag to select the area you want to erase from the PDF.
        </p>
      </div>
      <div className="space-y-2">
        <div className="flex items-start gap-2">
          <span className="text-xs font-bold text-primary mt-0.5">1.</span>
          <p className="text-xs text-muted-foreground">
            Click and hold on the PDF where you want to start erasing
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="text-xs font-bold text-primary mt-0.5">2.</span>
          <p className="text-xs text-muted-foreground">
            Drag to select the area (you'll see a red dashed rectangle)
          </p>
        </div>
        <div className="flex items-start gap-2">
          <span className="text-xs font-bold text-primary mt-0.5">3.</span>
          <p className="text-xs text-muted-foreground">
            Release to erase the selected area
          </p>
        </div>
      </div>
      <div className="bg-accent/50 p-3 rounded-md">
        <p className="text-xs text-muted-foreground">
          💡 <strong>Tip:</strong> The PDF is now displayed at higher resolution for easier text selection. Use zoom controls to get even closer!
        </p>
      </div>
    </div>
  );
};

export default EraseTool;